var e=(e,t,r)=>{let a=e.get(t);return void 0===a&&(a=r(),e.set(t,a)),a};export{e as default};